"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Check = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M10.355 16.448l-5.22-5.22a1.09 1.09 0 10-1.543 1.543l6.11 6.11a1.09 1.09 0 001.643-.117L20.51 6.545a1.09 1.09 0 10-1.745-1.309z" })));
exports.default = Check;
//# sourceMappingURL=index.js.map